import { FileSpreadsheet } from "lucide-react";

/**
 * Renders module selection radio cards for Excel import.
 * Props: modules [{value, label}], selected (string), onSelect (fn)
 */
export function ModuleSelector({ modules, selected, onSelect }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
      {modules.map((m) => (
        <label
          key={m.value}
          className={`flex items-center gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all ${
            selected === m.value
              ? "border-[#0D1B3E] bg-[#0D1B3E]/5"
              : "border-slate-200 hover:border-slate-300"
          }`}
        >
          <input
            type="radio"
            name="modul"
            value={m.value}
            checked={selected === m.value}
            onChange={() => onSelect(m.value)}
            className="sr-only"
          />
          <FileSpreadsheet
            size={16}
            className={selected === m.value ? "text-[#0D1B3E]" : "text-slate-400"}
          />
          <span
            className={`text-sm font-medium ${
              selected === m.value ? "text-[#0D1B3E]" : "text-slate-600"
            }`}
          >
            {m.label}
          </span>
        </label>
      ))}
    </div>
  );
}
